/** Kannada: rate estimates, what they rest on, suggestions, market answers, and the note on far-off offers. */
export const estimate = {
    "estimate.range_job": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ಇಡೀ ಕೆಲಸಕ್ಕೆ {low}–{high}.",
    "estimate.range_month": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ತಿಂಗಳಿಗೆ {low}–{high}.",
    "estimate.range_visit": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ಒಂದು ಸಲಕ್ಕೆ {low}–{high}.",
    "estimate.range_day": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ದಿನಕ್ಕೆ {low}–{high}.",
    "estimate.range_hour": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ಗಂಟೆಗೆ {low}–{high}.",
    "estimate.range_sqft": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ಪೇಂಟ್ ಮಾಡುವ ಒಂದು ಚದರ ಅಡಿಗೆ {low}–{high}.",
    "estimate.scope": " ({scope})",
    "estimate.rooms.bhk1": "1 ಬಿಎಚ್‌ಕೆ",
    "estimate.rooms.bhk2": "2 ಬಿಎಚ್‌ಕೆ",
    "estimate.rooms.bhk3": "3 ಬಿಎಚ್‌ಕೆ",
    "estimate.rooms.bhk4_plus": "4 ಬಿಎಚ್‌ಕೆ ಅಥವಾ ಹೆಚ್ಚು",
    "estimate.labour.yes": "ಕೂಲಿ ಮಾತ್ರ",
    "estimate.labour.no": "ಪೇಂಟ್ ಸಹಿತ",
    "estimate.frequency.daily": "ಪ್ರತಿದಿನ",
    "estimate.frequency.alternate_days": "ದಿನ ಬಿಟ್ಟು ದಿನ",
    "estimate.frequency.weekly": "ವಾರಕ್ಕೊಮ್ಮೆ",
    "estimate.people.1_2": "1–2 ಜನ",
    "estimate.people.3_4": "3–4 ಜನ",
    "estimate.people.5_plus": "5 ಅಥವಾ ಹೆಚ್ಚು ಜನ",
    "estimate.meals.1": "ದಿನಕ್ಕೆ 1 ಹೊತ್ತು ಊಟ",
    "estimate.meals.2": "ದಿನಕ್ಕೆ 2 ಹೊತ್ತು ಊಟ",
    "estimate.meals.3": "ದಿನಕ್ಕೆ 3 ಹೊತ್ತು ಊಟ",
    "estimate.hours.up_to_6": "ದಿನಕ್ಕೆ 6 ಗಂಟೆಯವರೆಗೆ",
    "estimate.hours.7_to_9": "ದಿನಕ್ಕೆ 7–9 ಗಂಟೆ",
    "estimate.hours.10_plus": "ದಿನಕ್ಕೆ 10 ಅಥವಾ ಹೆಚ್ಚು ಗಂಟೆ",
    "estimate.problem.fan": "ಫ್ಯಾನ್",
    "estimate.problem.switch": "ಸ್ವಿಚ್",
    "estimate.problem.light": "ಲೈಟ್",
    "estimate.problem.wiring": "ವೈರಿಂಗ್",
    "estimate.problem.leak": "ಸೋರಿಕೆ",
    "estimate.problem.tap": "ನಲ್ಲಿ",
    "estimate.problem.blockage": "ಕಟ್ಟಿಕೊಂಡಿರುವುದು",
    "estimate.problem.toilet": "ಟಾಯ್ಲೆಟ್",
    "estimate.problem.door": "ಬಾಗಿಲು",
    "estimate.problem.repair": "ರಿಪೇರಿ",
    "estimate.problem.assembly": "ಪೀಠೋಪಕರಣ ಜೋಡಣೆ",
    "estimate.problem.service": "ಸರ್ವಿಸ್",
    "estimate.problem.gas_refill": "ಗ್ಯಾಸ್ ತುಂಬಿಸುವುದು",
    "estimate.problem.install": "ಅಳವಡಿಕೆ",
    "estimate.jobs.one": "{place} ನಲ್ಲಿ GigSync ನ {count} ಕೆಲಸದಿಂದ.",
    "estimate.jobs.other": "{place} ನಲ್ಲಿ GigSync ನ {count} ಕೆಲಸಗಳಿಂದ.",
    "estimate.reason_jobs.one": "ಈ ಕೆಲಸಕ್ಕೆ ಸಾಮಾನ್ಯ ದರ {low}–{high}, GigSync ನ {count} ಕೆಲಸದಿಂದ.",
    "estimate.reason_jobs.other": "ಈ ಕೆಲಸಕ್ಕೆ ಸಾಮಾನ್ಯ ದರ {low}–{high}, GigSync ನ {count} ಕೆಲಸಗಳಿಂದ.",
    "estimate.market_none": "{place} ನಲ್ಲಿ {trade} ಸಾಮಾನ್ಯ ದರ ಇನ್ನೂ ಹೇಳಲಾಗದು: GigSync ನಲ್ಲಿ ಕೆಲಸಗಳು ಮತ್ತು ವೆಬ್‌ನಲ್ಲಿ ಬೆಲೆಗಳು ತುಂಬಾ ಕಡಿಮೆ.",
    "estimate.amount_below": "{amount} ಈ ವ್ಯಾಪ್ತಿಗಿಂತ ಕಡಿಮೆ.",
    "estimate.amount_within": "{amount} ಈ ವ್ಯಾಪ್ತಿಯೊಳಗೆ ಇದೆ.",
    "estimate.amount_above": "{amount} ಈ ವ್ಯಾಪ್ತಿಗಿಂತ ಹೆಚ್ಚು.",
    "estimate.answer": "{text}",
    "estimate.legal_min": "ಇದರಲ್ಲಿ ಯಾವುದೂ ಕಾನೂನಿನ ಕನಿಷ್ಠ {min} ಗಿಂತ ಕಡಿಮೆ ಇಲ್ಲ.",
    "estimate.suggest_rate": "{price} ರಿಂದ ಶುರು ಮಾಡಲು ಸಲಹೆ. ಇದನ್ನು ಆರಿಸಿ, ಅಥವಾ ನಿಮ್ಮ ಬೆಲೆ ಹೇಳಿ.",
    "estimate.suggest_min": "ಕನಿಷ್ಠ {price} ತೆಗೆದುಕೊಳ್ಳಲು ಸಲಹೆ. ಇದನ್ನು ಆರಿಸಿ, ಅಥವಾ ನಿಮ್ಮ ಬೆಲೆ ಹೇಳಿ.",
    "estimate.suggest_budget": "{price} ಬಜೆಟ್ ಸಲಹೆ. ಇದನ್ನು ಆರಿಸಿ, ಅಥವಾ ನಿಮ್ಮದು ಹೇಳಿ.",
    "estimate.use": "{price} ಇಡಿ",
    "estimate.below": "ಈ ಕೆಲಸದ ಸಾಮಾನ್ಯ ದರಕ್ಕಿಂತ ({low}–{high}) ತುಂಬಾ ಕಡಿಮೆ.",
    "estimate.above": "ಈ ಕೆಲಸದ ಸಾಮಾನ್ಯ ದರಕ್ಕಿಂತ ({low}–{high}) ತುಂಬಾ ಹೆಚ್ಚು.",
};
//# sourceMappingURL=estimate.js.map